<p-toast position="bottom-left">
</p-toast>
<div class="twofactor-wrapper twofa-login">
  <div class="column__figure">

    <h2>Multi-Factor <br>
      Authentication</h2>
    <div class="figure__icon"><img src="assets/images/multifactor.svg" alt="Manage Your Account"></div>
    <p>Manage Your Account</p>
  </div>
  <div class="column__content">
    <img src="assets/images/logo.svg" class="logo" alt="Reflecx">
    <h3>Manage your account</h3>
    <br/>
    <div>
      <p>Our system currently only supports YubiKey for multi-factor authentication (MFA). The device you attempted to configure isn’t compatible with our authentication process.</p>
      <p>To complete the login process, please click on Reset and Continue. You configure the Yubikey authentication from My Account.</p>
    </div>

    <div class="form-field">
      <button class="secondary" (click)="reset()">Reset & Continue</button>
    </div>
  </div>
</div>